import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlumbingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"plumbing"}/>
}
